import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-gamma',
  templateUrl: './icon-gamma.component.html',
  styleUrl: './icon-gamma.component.scss',
  standalone: false
})
export class IconGammaComponent {
  @Input() tooltip?: string;
}
